export default __webpack_public_path__ + "static/media/paymentGateway.ea29a8f3.svg";